import identity from 'lodash/identity.js';
/** Makes sure at least one value in array is truthy */
export const unarySome = (arr) => arr.some(identity);
/** Makes sure at least one argument is truthy */
export const selectUnarySome = (...args) => unarySome(args);
//# sourceMappingURL=unarySome.js.map